import axios from 'axios'
import { api } from '@/services/config'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import store from '@/store'

const editingStore = {
  namespaced: true,
  state: () => ({
    information_level_1: null,
    legaldoc_level_1: null,
    sio_level_1: null,
    k3l_level_1: null,
    kplh_level_1: null,
    revise_sipm_approve: null,
    validation_revise: null,
    review_from_landingpage: null,
  }),
  mutations: {
    SET_EDITING(state, payload) {
      state[payload.name] = payload.response
    },
    EMPTY_EDITING(state, payload) {
      state[payload.name] = {
        is_open: 0,
      }
    },
    async CLEAR_EDITING(state, payload) {
      const url = `${api}/api/v1/editing/clear-editing`

      const { user_id } = payload

      let updateData = {
        user_id,
      }

      try {
        const { data } = await axios({
          url,
          method: 'POST',
          data: updateData,
        })

        if (data && data.status == 'success') {
        }
      } catch (error) {}
    },
  },
  actions: {
    getVendorStatus: async ({ commit, state, rootState }, payload) => {
      const url = `${api}/api/v1/editing/vendor-editing?vendor_id=${payload.id}&name=${payload.name}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_EDITING', { response: data.data, name: payload.name })
      } catch (error) {
        await commit('EMPTY_EDITING', payload)
      }
    },
    getRequestStatus: async ({ commit, state, rootState }, payload) => {
      const url = `${api}/api/v1/editing/request-editing?request_id=${payload.id}&name=${payload.name}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_EDITING', { response: data.data, name: payload.name })
        // await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit('EMPTY_EDITING', payload)
        // await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    addEditingStatus: async (
      { commit, dispatch, state, rootState },
      payload
    ) => {
      await commit('level1/SET_LOADING', true, { root: true })
      const url = `${api}/api/v1/editing`
      const {
        is_open,
        open_by,
        user_id,
        vendor_id,
        request_id,
        desc,
        name,
      } = payload
      let updateData = {
        desc,
        is_open,
        open_by,
        user_id,
        vendor_id,
        request_id,
      }

      try {
        const { data } = await axios({
          url,
          method: 'POST',
          data: updateData,
        })

        if (data && data.status == 'success') {
          await commit('SET_EDITING', { response: data.data, name })
          await commit('level1/SET_LOADING', false, { root: true })
          if (payload && payload.onSuccess) {
            payload.onSuccess()
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF_OPEN',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
    deleteEditingStatus: async (
      { commit, dispatch, state, rootState },
      payload
    ) => {
      await commit('level1/SET_LOADING', true, { root: true })
      const url = `${api}/api/v1/editing/delete`
      const {
        id,
        is_open,
        open_by,
        user_id,
        vendor_id,
        request_id,
        name,
      } = payload
      let updateData = {
        id,
        is_open,
        open_by,
        user_id,
        vendor_id,
        request_id,
      }

      try {
        const { data } = await axios({
          url,
          method: 'POST',
          data: updateData,
        })

        if (data && data.status == 'success') {
          await commit('SET_EDITING', { response: updateData, name })
          await commit('level1/SET_LOADING', false, { root: true })
        }
      } catch (error) {
        await commit(
          'SET_NOTIF_OPEN',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('level1/SET_LOADING', false, { root: true })
      }
    },
  },
}

export default editingStore
